module.exports = __webpack_public_path__ + "img/WDC.4fc9f5e5.png";